import React, { ReactNode, useEffect } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { colors } from '@shared/tokens/colors.stylex';
import { CrossIcon } from '@shared/assets/icons';

interface ToastProps {
  id: number;
  message: ReactNode;
  type: 'success' | 'error' | 'info' | 'warning';
  onClose: (id: number) => void;
  index: number;
  duration: number;
  closable?: boolean;
  details?: string;
  onDetailsClick?: () => void;
}

const OneToast: React.FC<ToastProps> = ({
  id,
  message,
  type,
  onClose,
  index,
  duration,
  closable,
  details,
  onDetailsClick,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration + 1000);
    return () => clearTimeout(timer);
  }, [id, onClose, closable]);

  return (
    <div {...stylex.props([styles.base(index, duration), styles[type]])}>
      {message}
      {details && (
        <button type="button" {...stylex.props(styles.details)} onClick={onDetailsClick}>
          Подробнее
        </button>
      )}
      {closable && (
        <button
          type="button"
          onClick={() => onClose(id)}
          {...stylex.props(styles.close)}
          aria-label="Закрыть уведомление"
        >
          <CrossIcon color={colors.primaryText} width="24" height="24" />
        </button>
      )}
    </div>
  );
};

export default OneToast;
